import React from 'react';
import './EasyButton.css';

interface EasyButtonProps {
  width?: string | number;
  height?: number;
  onClick?: () => void;
  type?: 'primary' | 'secondary';
  marginTop?: number;
  marginBottom?: number;
  /** 覆盖 primary 背景色（如登录框主题色） */
  backgroundColor?: string;
  children: React.ReactNode;
}

const EasyButton: React.FC<EasyButtonProps> = ({
  width,
  height = 40,
  onClick,
  type = 'primary',
  marginTop = 10,
  marginBottom = 10,
  backgroundColor,
  children
}) => {
  const buttonStyle: React.CSSProperties = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: `${height}px`,
    marginTop: `${marginTop}px`,
    marginBottom: `${marginBottom}px`,
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'opacity 0.2s ease',
  };

  const getBackgroundColor = () => {
    switch (type) {
      case 'primary':
        return '#00BF58';
      case 'secondary':
        return '#0A95AA';
      default:
        return '#00BF58';
    }
  };

  buttonStyle.backgroundColor = backgroundColor ?? getBackgroundColor();
  buttonStyle.color = '#FFFFFF';

  return (
    <button
      style={buttonStyle}
      onClick={onClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.opacity = '0.8';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.opacity = '1';
      }}
    >
      {children}
    </button>
  );
};

export default EasyButton; 